var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStakeholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 77.5H21.25C21.94 77.5 22.5 76.94 22.5 76.25V66.25C22.5 62.6887 20.3575 59.6225 17.2975 58.2587C18.9475 56.8812 20 54.8125 20 52.5C20 48.3637 16.6362 45 12.5 45C8.36375 45 5 48.3637 5 52.5C5 54.8125 6.0525 56.8812 7.7025 58.2587C4.6425 59.6225 2.5 62.6887 2.5 66.25V76.25C2.5 76.94 3.06 77.5 3.75 77.5ZM12.5 62.115L13.6538 65L12.5 67.885L11.3462 65L12.5 62.115ZM12.5 57.5C9.8575 57.5 7.71 55.4338 7.53375 52.835C9.00625 51.8138 10.7037 51.25 12.5 51.25C14.2963 51.25 15.9937 51.8138 17.4662 52.835C17.29 55.4338 15.1425 57.5 12.5 57.5ZM12.5 47.5C14.1138 47.5 15.5363 48.2812 16.4513 49.4712C15.2 49 13.8713 48.75 12.5 48.75C11.1287 48.75 9.8 49 8.54875 49.4712C9.46375 48.2812 10.8862 47.5 12.5 47.5ZM5 66.25C5 63.0175 7.4775 60.38 10.6287 60.0625L8.84 64.535C8.72125 64.8337 8.72125 65.165 8.84 65.4637L11.34 71.7137C11.53 72.1887 11.9888 72.5 12.5 72.5C13.0112 72.5 13.47 72.1888 13.6613 71.715L16.1613 65.465C16.28 65.1663 16.28 64.835 16.1613 64.5363L14.3725 60.0637C17.5225 60.38 20 63.0175 20 66.25V75H5V66.25ZM72.2975 58.2587C73.9475 56.8812 75 54.8125 75 52.5C75 48.3637 71.6363 45 67.5 45C63.3638 45 60 48.3637 60 52.5C60 54.8125 61.0525 56.8812 62.7025 58.2587C59.6425 59.6225 57.5 62.6887 57.5 66.25V76.25C57.5 76.94 58.06 77.5 58.75 77.5H76.25C76.94 77.5 77.5 76.94 77.5 76.25V66.25C77.5 62.6887 75.3575 59.6225 72.2975 58.2587ZM67.5 62.115L68.6537 65L67.5 67.885L66.3462 65L67.5 62.115ZM67.5 57.5C64.8575 57.5 62.71 55.4338 62.5338 52.835C64.0063 51.8138 65.7038 51.25 67.5 51.25C69.2962 51.25 70.9938 51.8138 72.4662 52.835C72.29 55.4338 70.1425 57.5 67.5 57.5ZM67.5 47.5C69.1137 47.5 70.5362 48.2812 71.4512 49.4712C70.2 49 68.8712 48.75 67.5 48.75C66.1287 48.75 64.8 49 63.5488 49.4712C64.4638 48.2812 65.8862 47.5 67.5 47.5ZM75 75H60V66.25C60 63.0175 62.4775 60.38 65.6287 60.0625L63.84 64.535C63.7212 64.8337 63.7212 65.165 63.84 65.4637L66.34 71.7137C66.53 72.1887 66.9887 72.5 67.5 72.5C68.0113 72.5 68.47 72.1888 68.6613 71.715L71.1613 65.465C71.28 65.1663 71.28 64.835 71.1613 64.5363L69.3725 60.0637C72.5225 60.38 75 63.0175 75 66.25V75Z",
    fill: "url(#paint0_linear_180_6694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 23.75H36.25V26.25H43.75V23.75Z",
    fill: "url(#paint1_linear_180_6694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 28.75H36.25V31.25H43.75V28.75Z",
    fill: "url(#paint2_linear_180_6694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 33.75H36.25V36.25H43.75V33.75Z",
    fill: "url(#paint3_linear_180_6694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 32.5H51.25V35H53.75V32.5Z",
    fill: "url(#paint4_linear_180_6694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 37.5H51.25V40H53.75V37.5Z",
    fill: "url(#paint5_linear_180_6694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 32.5H26.25V35H28.75V32.5Z",
    fill: "url(#paint6_linear_180_6694)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 37.5H26.25V40H28.75V37.5Z",
    fill: "url(#paint7_linear_180_6694)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 43.75V28.75C58.75 28.06 58.19 27.5 57.5 27.5H48.75V20C48.75 19.31 48.19 18.75 47.5 18.75H46.25V17.5C46.25 15.4325 44.5675 13.75 42.5 13.75H41.25V11.25H38.75V13.75H37.5C35.4325 13.75 33.75 15.4325 33.75 17.5V18.75H32.5C31.81 18.75 31.25 19.31 31.25 20V27.5H22.5C21.81 27.5 21.25 28.06 21.25 28.75V43.75C21.25 44.44 21.81 45 22.5 45H31.25C31.25 45.69 31.81 46.25 32.5 46.25H47.5C48.19 46.25 48.75 45.69 48.75 45H57.5C58.19 45 58.75 44.44 58.75 43.75ZM23.75 42.5V30H31.25V42.5H23.75ZM36.25 17.5C36.25 16.8112 36.8113 16.25 37.5 16.25H42.5C43.1888 16.25 43.75 16.8112 43.75 17.5V18.75H36.25V17.5ZM38.75 43.75V41.25H41.25V43.75H38.75ZM46.25 43.75H43.75V40C43.75 39.31 43.19 38.75 42.5 38.75H37.5C36.81 38.75 36.25 39.31 36.25 40V43.75H33.75V21.25H46.25V43.75ZM56.25 42.5H48.75V30H56.25V42.5ZM56.25 57.5H51.25C51.25 55.4325 49.5675 53.75 47.5 53.75H43.75V52.5C43.75 50.4325 42.0675 48.75 40 48.75H31.25C29.1825 48.75 27.5 50.4325 27.5 52.5V52.9775L23.1912 55.1325C22.7675 55.3438 22.5 55.7762 22.5 56.25C22.5 56.7238 22.7675 57.1562 23.1912 57.3688L27.5 59.5225V60C27.5 62.0675 29.1825 63.75 31.25 63.75H35V65C35 67.0675 36.6825 68.75 38.75 68.75H47.5C49.5675 68.75 51.25 67.0675 51.25 65V64.35L57.0312 59.725C57.4463 59.3937 57.605 58.8363 57.43 58.335C57.2537 57.835 56.7812 57.5 56.25 57.5ZM31.25 61.25C30.5613 61.25 30 60.6888 30 60V58.75C30 58.2762 29.7325 57.8438 29.3088 57.6312L26.545 56.25L29.3088 54.8688C29.7325 54.6562 30 54.2238 30 53.75V52.5C30 51.8112 30.5613 51.25 31.25 51.25H40C40.6888 51.25 41.25 51.8112 41.25 52.5V53.75H38.75C36.6825 53.75 35 55.4325 35 57.5V61.25H31.25ZM49.2188 62.7738C48.9225 63.0113 48.75 63.37 48.75 63.75V65C48.75 65.6888 48.1888 66.25 47.5 66.25H38.75C38.0613 66.25 37.5 65.6888 37.5 65V57.5C37.5 56.8112 38.0613 56.25 38.75 56.25H47.5C48.1888 56.25 48.75 56.8112 48.75 57.5V58.75C48.75 59.44 49.31 60 50 60H52.6862L49.2188 62.7738ZM72.8463 44.0375C73.4463 41.5013 73.75 38.8812 73.75 36.25C73.75 33.62 73.4463 31 72.8463 28.4625L70.4137 29.0375C70.9688 31.3862 71.25 33.8125 71.25 36.25C71.25 38.6875 70.9688 41.115 70.4137 43.4625L72.8463 44.0375ZM40 2.5C34.5125 2.5 29.065 3.8475 24.2463 6.395L25.415 8.605C29.875 6.24625 34.9188 5 40 5C45.08 5 50.1237 6.24625 54.5837 8.605L55.7525 6.39375C50.9325 3.84625 45.4863 2.5 40 2.5ZM7.15375 28.4625C6.55375 31 6.25 33.62 6.25 36.25C6.25 38.8812 6.55375 41.5013 7.15375 44.0375L9.58625 43.4625C9.03125 41.115 8.75 38.6875 8.75 36.25C8.75 33.8125 9.03125 31.3862 9.58625 29.0375L7.15375 28.4625ZM13.75 20C13.0613 20 12.5 19.4387 12.5 18.75H10C10 20.3775 11.0487 21.7525 12.5 22.27V23.75H15V22.27C16.4513 21.7525 17.5 20.3775 17.5 18.75C17.5 16.6825 15.8175 15 13.75 15C13.0613 15 12.5 14.4388 12.5 13.75C12.5 13.0612 13.0613 12.5 13.75 12.5C14.4388 12.5 15 13.0612 15 13.75H17.5C17.5 12.1225 16.4513 10.7475 15 10.23V8.75H12.5V10.23C11.0487 10.7475 10 12.1225 10 13.75C10 15.8175 11.6825 17.5 13.75 17.5C14.4388 17.5 15 18.0612 15 18.75C15 19.4387 14.4388 20 13.75 20Z",
    fill: "url(#paint8_linear_180_6694)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 27.5C19.9525 27.5 25 22.4525 25 16.25C25 10.0475 19.9525 5 13.75 5C7.5475 5 2.5 10.0475 2.5 16.25C2.5 22.4525 7.5475 27.5 13.75 27.5ZM13.75 7.5C18.575 7.5 22.5 11.425 22.5 16.25C22.5 21.075 18.575 25 13.75 25C8.925 25 5 21.075 5 16.25C5 11.425 8.925 7.5 13.75 7.5ZM66.25 12.5C66.9388 12.5 67.5 13.0612 67.5 13.75H70C70 12.1225 68.9512 10.7475 67.5 10.23V8.75H65V10.23C63.5488 10.7475 62.5 12.1225 62.5 13.75C62.5 15.8175 64.1825 17.5 66.25 17.5C66.9388 17.5 67.5 18.0612 67.5 18.75C67.5 19.4388 66.9388 20 66.25 20C65.5612 20 65 19.4388 65 18.75H62.5C62.5 20.3775 63.5488 21.7525 65 22.27V23.75H67.5V22.27C68.9512 21.7525 70 20.3775 70 18.75C70 16.6825 68.3175 15 66.25 15C65.5612 15 65 14.4388 65 13.75C65 13.0612 65.5612 12.5 66.25 12.5Z",
    fill: "url(#paint9_linear_180_6694)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.25 5C60.0475 5 55 10.0475 55 16.25C55 22.4525 60.0475 27.5 66.25 27.5C72.4525 27.5 77.5 22.4525 77.5 16.25C77.5 10.0475 72.4525 5 66.25 5ZM66.25 25C61.425 25 57.5 21.075 57.5 16.25C57.5 11.425 61.425 7.5 66.25 7.5C71.075 7.5 75 11.425 75 16.25C75 21.075 71.075 25 66.25 25Z",
    fill: "url(#paint10_linear_180_6694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_180_6694",
    x1: 2.50037,
    y1: 61.2502,
    x2: 77.5,
    y2: 61.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_180_6694",
    x1: 36.25,
    y1: 25,
    x2: 43.75,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_180_6694",
    x1: 36.25,
    y1: 30,
    x2: 43.75,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_180_6694",
    x1: 36.25,
    y1: 35,
    x2: 43.75,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_180_6694",
    x1: 51.25,
    y1: 33.75,
    x2: 53.75,
    y2: 33.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_180_6694",
    x1: 51.25,
    y1: 38.75,
    x2: 53.75,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_180_6694",
    x1: 26.25,
    y1: 33.75,
    x2: 28.75,
    y2: 33.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_180_6694",
    x1: 26.25,
    y1: 38.75,
    x2: 28.75,
    y2: 38.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_180_6694",
    x1: 6.25034,
    y1: 35.6255,
    x2: 73.75,
    y2: 35.6255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_180_6694",
    x1: 2.50034,
    y1: 16.2502,
    x2: 70,
    y2: 16.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_180_6694",
    x1: 55.0001,
    y1: 16.2502,
    x2: 77.5,
    y2: 16.2502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CE05A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C6A69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholder);
export default __webpack_public_path__ + "static/media/stakeholder.f12b92bcb249ecfda4e50e7c15ed6d70.svg";
export { ForwardRef as ReactComponent };